export default {
  error: state => state.error,
  formLoading: state => state.formLoading,
  success: state => state.success,
  loading: state => state.loading,
  user: state => state.user,
  users: state => state.users,
  searchUsers: state => state.searchUsers,
  boardMembers: state => state.boardMembers,
};



// WEBPACK FOOTER //
// ./src/components/Users/getters.js